module.exports = __webpack_public_path__ + "img/product-atomizer-sopuria-Litdrop.0169b4d6.jpg";